import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  text: 'En 3 meses tengo cédula en Paraguay. Mis $8k ahora valen el doble y camino por la calle sin miedo a la policía.',
  author: 'José R.',
  role: 'Ex-NY',
  date: 'Feb 14, 2026',
  avatar: 'JR',
  rating: 5,
  verified: true,
  highlight: 'En 3 meses tengo cédula en Paraguay'
}, {
  text: 'Llevaba 15 años indocumentada. Con mis ahorros logré la residencia en España. En dos años podré pedir la ciudadanía europea.',
  author: 'María Elena C.',
  role: 'Ex-California',
  date: 'Ene 28, 2026',
  avatar: 'MC',
  rating: 5,
  verified: true,
  highlight: 'En dos años tendré ciudadanía europea'
}, {
  text: 'La guía bancaria me salvó. Pude mover mis $12,000 sin que el banco me bloqueara la cuenta al salir del país.',
  author: 'Carlos M.',
  role: 'Ex-Texas',
  date: 'Feb 3, 2026',
  avatar: 'CM',
  rating: 5,
  verified: true,
  highlight: 'Pude mover mis ahorros sin bloqueos'
}, {
  text: 'Estaba aterrado con mi orden de deportación. El manual me enseñó que salir voluntariamente era mi derecho y mi capital me abrió las puertas en Panamá.',
  author: 'Luis G.',
  role: 'Ex-Florida',
  date: 'Ene 15, 2026',
  avatar: 'LG',
  rating: 5,
  verified: true,
  highlight: 'Mi capital me abrió las puertas'
}, {
  text: 'Por fin mis hijos nacidos en USA tendrán un futuro sin ver a sus padres esconderse. El Salvador nos recibió con los brazos abiertos.',
  author: 'Familia Ramírez',
  role: 'Ex-Illinois',
  date: 'Feb 20, 2026',
  avatar: 'FR',
  rating: 4,
  verified: true,
  highlight: 'Un futuro sin escondernos'
}, {
  text: 'Gasté $4,000 en un notario que no hizo nada. Esta guía por menos de $10 me dio el mapa exacto para conseguir residencia legal en Portugal.',
  author: 'Ana P.',
  role: 'Ex-New Jersey',
  date: 'Feb 11, 2026',
  avatar: 'AP',
  rating: 5,
  verified: true,
  highlight: 'El mapa exacto para residencia legal'
}];
function StarRating({
  count = 5
}: {
  count?: number;
}) {
  return <div className="flex items-center gap-0.5" data-id="element-382">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-3.5 h-3.5 ${i < count ? 'fill-[#00b67a] text-[#00b67a]' : 'text-gray-300'}`} data-id="element-383" />)}
    </div>;
}
function AvatarCircle({
  initials
}: {
  initials: string;
}) {
  const colors: Record<string, string> = {
    JR: '#7c6b3a',
    MC: '#5a7c6b',
    CM: '#6b5a7c',
    LG: '#7c5a5a',
    FR: '#5a6b7c',
    AP: '#7c7a5a'
  };
  const bg = colors[initials] || '#7c6b3a';
  return <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{
    backgroundColor: bg
  }} data-id="element-384">
      {initials}
    </div>;
}
export function TestimonialsSection() {
  const avgRating = 4.9;
  const totalReviews = 5124;
  return <section className="py-8 md:py-14 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-385">
      <div className="max-w-[860px] mx-auto" data-id="element-386">
        {/* Header — Trustpilot style */}
        <div className="text-center mb-6 md:mb-10" data-id="element-387">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-388">
            Casos de Éxito
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-4 md:mb-6" data-id="element-389">
            Lo que dicen quienes ya activaron su Plan B
          </h2>

          {/* Aggregate score */}
          <div className="inline-flex items-center gap-3 md:gap-6 bg-[var(--bg-card)] border border-[var(--border-subtle)] rounded-xl px-4 md:px-6 py-3 md:py-4 shadow-sm" data-id="element-390">
            <div className="text-center" data-id="element-391">
              <div className="text-3xl md:text-4xl font-bold text-[var(--text-heading)] font-serif leading-none mb-1" data-id="element-392">
                {avgRating}
              </div>
              <StarRating count={5} data-id="element-393" />
            </div>
            <div className="w-px h-10 bg-[var(--border-subtle)]" data-id="element-394" />
            <div className="text-center" data-id="element-395">
              <div className="text-lg md:text-xl font-bold text-[var(--text-heading)]" data-id="element-396">
                {totalReviews.toLocaleString()}+
              </div>
              <p className="text-[10px] text-[var(--text-muted)] uppercase tracking-wide" data-id="element-397">
                Casos exitosos
              </p>
            </div>
          </div>
        </div>

        {/* Review cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-398">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07
        }} className="bg-[var(--bg-card)] rounded-xl border border-[var(--border-subtle)] p-3.5 md:p-5 flex flex-col gap-2 md:gap-3 shadow-sm" data-id="element-399">
              {/* Top row */}
              <div className="flex items-start justify-between gap-2" data-id="element-400">
                <div className="flex items-center gap-2" data-id="element-401">
                  <AvatarCircle initials={t.avatar} data-id="element-402" />
                  <div data-id="element-403">
                    <p className="text-[var(--text-heading)] text-xs md:text-sm font-bold leading-tight" data-id="element-404">
                      {t.author}
                    </p>
                    <p className="text-[var(--text-muted)] text-[10px]" data-id="element-405">
                      {t.role}
                    </p>
                  </div>
                </div>
                {t.verified && <div className="flex items-center gap-1 text-[10px] text-[#00b67a] flex-shrink-0" data-id="element-406">
                    <CheckCircle className="w-3 h-3" data-id="element-407" />
                  </div>}
              </div>

              {/* Highlight badge */}
              <div className="bg-[var(--accent-soft)] border border-[var(--accent)]/20 rounded px-2 py-1" data-id="element-408">
                <p className="text-[var(--accent)] text-[10px] md:text-[11px] font-semibold leading-snug" data-id="element-409">
                  "{t.highlight}"
                </p>
              </div>

              {/* Full review */}
              <p className="text-[var(--text-muted)] text-xs md:text-sm leading-relaxed flex-1 italic" data-id="element-410">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>

        {/* Footer trust line */}
        <div className="mt-5 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-2 text-[10px] text-[var(--text-muted)]" data-id="element-411">
          <div className="flex items-center gap-1.5" data-id="element-412">
            <CheckCircle className="w-3.5 h-3.5 text-[#00b67a]" data-id="element-413" />
            <span data-id="element-414">93% aprobación de gobiernos receptores</span>
          </div>
          <span className="hidden sm:inline opacity-30" data-id="element-415">·</span>
          <span data-id="element-416">4.9/5 · +5,000 casos exitosos documentados</span>
        </div>
      </div>
    </section>;
}